import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/services")({
  head: () => ({
    meta: [
      { title: "Cleaning Services in Wetumpka, AL | Pretty in Pink" },
      {
        name: "description",
        content:
          "Residential and commercial cleaning services in Wetumpka, AL — house cleaning, deep cleaning, move-in/move-out, office, and post-construction cleaning.",
      },
      { property: "og:title", content: "Cleaning Services | Wetumpka, AL" },
      {
        property: "og:description",
        content:
          "Residential and commercial cleaning services in Wetumpka, AL and surrounding areas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => <Outlet />,
});
